import React from 'react';
import ActionTextButton from "../Templates/ActionTextButton";

const EditTextButton = ({className, onClick}) => {
  return (
    <ActionTextButton
      className={`s-color-blue blue ${className}`}
      onClick={onClick}
      icon="edit"
      text="Editar"
    />
  );
};

export default EditTextButton;
